import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  label: {
    description: 'Font size label',
    defaultMessage: 'Font Size',
    id: 'xxkJRL',
  },
});
